import { render, staticRenderFns } from "./comment-info.vue?vue&type=template&id=4693fd7d&scoped=true&"
import script from "./comment-info.vue?vue&type=script&lang=js&"
export * from "./comment-info.vue?vue&type=script&lang=js&"
import style0 from "./comment-info.vue?vue&type=style&index=0&id=4693fd7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4693fd7d",
  null
  
)

export default component.exports